var map = {
	"./action.vue": 26640,
	"./importcsv.vue": 28754,
	"./layout.vue": 51600,
	"./multiplechoice.vue": 96898,
	"./selection.vue": 23522,
	"./singlechoice.vue": 74211,
	"./smarttablequestion.vue": 46588,
	"./tablequestion.vue": 57715,
	"./textnumber.vue": 94898,
	"./yesno.vue": 65459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56849;